module.exports = __webpack_public_path__ + "static/cardrating-d5da6a463f9eb163eccba668116f72f6.png";